export const MainConfig = {
  AppDetails: {
    app_name: "api-nexus",
    app_description: "",
    app_identifier: "systems.plum.api-nexus",
    ios_app_version: "1.4.51",
    android_app_version: 81,
  },
  //!!PROD CONFIG
  FirebaseConfig: {
    apiKey: "AIzaSyDpoc3k5EVmd5DDO4PdepJGQq1_om73-kU",
    authDomain: "api-nexus-f7bcd.firebaseapp.com",
    databaseURL:
      "https://api-nexus-f7bcd-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "api-nexus-f7bcd",
    storageBucket: "api-nexus-f7bcd.appspot.com",
    messagingSenderId: "193055991773",
    appId: "1:193055991773:web:0699e548b7513a4c7a3834",
    measurementId: "G-52Q1MGCVFY",
  },

  SentryMobileConfig: {
    DSN: "https://e4220460b1acdfb72ba481d7b2f4e914@sentry.plum.systems/2",
    SHE: "https://sentry.plum.systems/api/3/security/?sentry_key=80d11da8a796ada543df970cd50c6bff",//Security Header Endpoint
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.3, //!! WHEN DOING RELEASES PLEASE SET THIS TO 0.3 OR ELSE WE WILL EXPERENCE LAG IN THE APP
    replaysOnErrorSampleRate: 1.0,
  },

  SentryWebConfig: {
    DSN: "https://15ead7777d89dbf5e452b01c1c787427@sentry.plum.systems/4",
    SHE: "https://sentry.plum.systems/api/3/security/?sentry_key=80d11da8a796ada543df970cd50c6bff",//Security Header Endpoint
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0, //!! WHEN DOING RELEASES PLEASE SET THIS TO 0.3 OR ELSE WE WILL EXPERENCE LAG IN THE APP
    replaysOnErrorSampleRate: 1.0,
  },


  //!!DEV CONFIG
  // FirebaseConfig: {
  //   apiKey: "AIzaSyAXWWt6V5N_7UqpunLljnhdgYWktm1DGRc",
  //   authDomain: "api-nexus-dev.firebaseapp.com",
  //   databaseURL: "https://api-nexus-dev-default-rtdb.firebaseio.com",
  //   projectId: "api-nexus-dev",
  //   storageBucket: "api-nexus-dev.firebasestorage.app",
  //   messagingSenderId: "389154974697",
  //   appId: "1:389154974697:web:b45b60ae879bd60c817978",
  //   measurementId: "G-E716DR9JPN"
  // },
  //   apiKey: "AIzaSyAXWWt6V5N_7UqpunLljnhdgYWktm1DGRc",
  //   authDomain: "api-nexus-dev.firebaseapp.com",
  //   databaseURL: "https://api-nexus-dev-default-rtdb.firebaseio.com",
  //   projectId: "api-nexus-dev",
  //   storageBucket: "api-nexus-dev.firebasestorage.app",
  //   messagingSenderId: "389154974697",
  //   appId: "1:389154974697:web:b45b60ae879bd60c817978",
  //   measurementId: "G-E716DR9JPN"
  // },


  Google_Map_Key: "AIzaSyD1TDkvKi4_HGpyjfpF18sYBPlmq4YN1Nw",

  Google_Calendar_Key: "AIzaSyD1TDkvKi4_HGpyjfpF18sYBPlmq4YN1Nw",
  Calendar_Client_Id:
    "430295662772-sqbdmak3i8cgtdep1sealud32bqm717j.apps.googleusercontent.com",
  Calendar_Discovery_Docs:
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
  Calender_Scope: "https://www.googleapis.com/auth/calendar.events",

  facebookAppId: "2844848755765608",
  PurchaseDetails: {
    CodeCanyon_Purchase_Code: "72a20f0d-c950-4ef9-9e1e-478174037339",
    Buyer_Email_Address: "lucien@plum.systems",
  },
  // {
  //     "clientId": "1:430295662772:web:7a94ca2987e0909f4717e1",
  //     Google_Calendar_Api: "AIzaSyDrU0ml2eiquhBKAbDxvWW2AvTXdn4N6PM",
  //     "scope": "https://www.googleapis.com/auth/calendar",
  //     "discoveryDocs": [
  //       "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
  //     ]
  //   }
};
